import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import TextField from 'material-ui/TextField';

import AppConstants from '../../constants/AppConstants';

const styles = {
  radioButton: {
    marginBottom: 4,
    marginLeft: 12,
  },
  errorStyle: {
    color: AppConstants.colors.accent1Color,
  },
}

class AmpFormSeparationChar extends Component {

  static propTypes = {
    defaultValue: PropTypes.string.isRequired,
    /**
     * Change callback
     * @param {String} value
     */
    onChange: PropTypes.func.isRequired,
    /**
     * Show 'Same as original' option
     */
    showSame: PropTypes.bool,    
    /**
     * Show 'Auto-detect' option
     */
    showAuto: PropTypes.bool,    
  }

  constructor(props) {
    super(props);
    this.state = {
      separationChar: props.defaultValue,
      separationCustomChar: '',
    };
  }

  setSeparationCharToOther = () => {
    this.setState({
      separationChar: 'other',
    })
    this.props.onChange(this.state.separationCustomChar);
  }

  handleSeparatorChange = (event, val) => {
    this.setState({ separationChar: val });
    // Bring focus to textfield when other is selected
    if (val === 'other' && this.refs.customSeparator) {
      this.refs.customSeparator.focus();
    } else {
      this.props.onChange(val);
    }
  }

  handleCustomSeparatorChange = (e, val) => {
    this.setState({ separationCustomChar: val });
    this.props.onChange(val);
  }

  render() {
    styles.optionalSameButton = Object.assign({}, styles.radioButton);
    styles.optionalAutoButton = Object.assign({}, styles.radioButton);
    if (!this.props.showSame) {
      styles.optionalSameButton.display = 'none';
    }
    if (!this.props.showAuto) {
      styles.optionalAutoButton.display = 'none';
    }

    return (
      <div>
        <RadioButtonGroup
          name="separation_char"
          valueSelected={this.state.separationChar}
          onChange={this.handleSeparatorChange}
        >
          <RadioButton
            value="same"
            label="Same as original"
            style={styles.optionalSameButton}
          />
          <RadioButton
            value="auto"
            label={<span>Auto-detect <i>(comma, tab or pipe)</i></span>}
            style={styles.optionalAutoButton}
          />
          <RadioButton
            value=","
            label="Comma"
            style={styles.radioButton}
          />
          <RadioButton
            value=";"
            label="Semi-colon"
            style={styles.radioButton}
          />
          <RadioButton
            value="	"
            label="Tab"
            style={styles.radioButton}
          />
          <RadioButton
            value=" "
            label="Space"
            style={styles.radioButton}
          />
          <RadioButton
            value="other"
            label="Other:"
            style={styles.radioButton}
          />
        </RadioButtonGroup>
        <TextField
          ref="customSeparator"
          hintText="Enter your custom separator here"
          errorStyle={styles.errorStyle}
          maxLength={2}
          onFocus={this.setSeparationCharToOther}
          onChange={this.handleCustomSeparatorChange}
        />
      </div>
    );
  }
}
export default AmpFormSeparationChar;



// WEBPACK FOOTER //
// ./src/components/AmpFormSeparationChar/index.jsx